import React from 'react';

import { Icon, Loader } from 'semantic-ui-react';

import { FormFieldBase } from './FormFieldBase';

import './FormTextArea.scss';

export const FormTextArea = ({
  placeholder,
  value,
  onChange,
  disabled,
  icon,
  loading,
  name,
  id,
  type,
  maxLength,
  cols,
  readOnly,
  rows,
  autoFocus,
  ...otherProps
}) => (
  <FormFieldBase
    component={
      <React.Fragment>
        <textarea
          autoFocus={autoFocus}
          maxLength={maxLength}
          cols={cols}
          readOnly={readOnly}
          rows={rows}
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={e => onChange(e, { value: e.target.value })}
          disabled={disabled}
        />
        {loading && (
          <Loader size="tiny" style={{ margin: '8px 7px 0 0' }} inline active />
        )}
        {!loading &&
          !!icon &&
          (typeof icon === 'string' ? (
            <Icon name={icon} />
          ) : (
            !!icon.name && <IconFromObj {...icon} />
          ))}
      </React.Fragment>
    }
    disabled={disabled}
    {...otherProps}
  />
);

const IconFromObj = ({ loading, ...otherProps }) => {
  return <Icon {...otherProps} />;
};

export default FormTextArea;
